import React from 'react';
import { useQuery } from '@apollo/client';
import {
  UserOrganisationAssigneeBreakdownDocument,
  UserOrganisationAssigneeBreakdownQuery,
} from 'src/graphql/generated/graphql';
import { useTranslation } from 'react-i18next';
import { Routes } from 'src/components/common/router/constants';
import { Link } from 'src/components/common/link';
import { useDeviceContext } from 'src/context/device.context';
import { UserBadge as MembersAssignedIcon, Error as ErrorIcon } from '@otp/icons';
import Grid from '@mui/material/Grid';
import { Card, Typography } from '@otp/ui';

export const MembersBreakdown = () => {
  const { t } = useTranslation();
  const { isMobile } = useDeviceContext();

  const { data } = useQuery<UserOrganisationAssigneeBreakdownQuery>(
    UserOrganisationAssigneeBreakdownDocument,
    {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-only',
    },
  );
  const assigneeBreakdown = data?.userOrganisationAssigneeBreakdown;

  return (
    <Grid container gap={2} direction="column">
      <Grid item xs={12}>
        <Card
          className="bg-[#F8F9FD] w-full rounded-xl"
          noBorder
        >
          <Grid container alignItems="center">
            <MembersAssignedIcon />
            <Typography
              variant="body1"
              fontWeight="medium"
              fontFamily="Inter"
              className="ml-2"
            >
              {t('my-organisation.manage-otps-v2.members-assigned')}
            </Typography>
          </Grid>
          <Link
            to={Routes.users.path}
            style={{ textDecoration: 'none' }}
            className="mt-4"
          >
            <Card
              className="bg-[#F8F9FD] hover:border-[#CBD5E1] px-6 py-4 rounded-2xl hover:bg-gray-100 w-full"
              isLink
              linkIconClassName="absolute right-3 top-1/2 -translate-y-1/2"
            >
              <Typography variant="inherit" fontFamily="Inter">
                {assigneeBreakdown?.assigned || 0}{' '}
                {t('my-organisation.manage-otps-v2.assigned')}
              </Typography>
            </Card>
          </Link>
        </Card>
      </Grid>

      <Grid item xs={12}>
        <Card className="bg-[#F8F9FD] w-full rounded-xl" noBorder>
          <Grid container alignItems="center">
            <ErrorIcon />
            <Typography
              variant="body1"
              fontWeight="medium"
              fontFamily="Inter"
              className="ml-2"
            >
              {t('my-organisation.manage-otps-v2.members-unassigned')}
            </Typography>
          </Grid>
          <Link
            to={Routes.users.path}
            style={{ textDecoration: 'none' }}
            className="mt-4"
          >
            <Card
              className="bg-[#F8F9FD] hover:border-[#CBD5E1] px-6 py-4 rounded-2xl hover:bg-gray-100 w-full"
              isLink
              linkIconClassName="absolute right-3 top-1/2 -translate-y-1/2"
            >
              <Typography variant="inherit" fontFamily="Inter">
                {assigneeBreakdown?.unassigned || 0}{' '}
                {t('my-organisation.manage-otps-v2.unassigned')}
              </Typography>
            </Card>
          </Link>
        </Card>
      </Grid>
    </Grid>
  );
};
